import React from 'react';


class Badge extends React.Component {
    constructor(props) {
        super(props);
    }

    applyType(type) {
        switch (type) {
            case "primary":
                return " bg-primary text-white ";
            case "secondary":
                return " bg-secondary text-white ";
            case "success":
                return " bg-green1-dark text-white ";
            case "danger":
                return " bg-red2-dark text-white ";
            case "warning":
                return " bg-highlight ";
            case "default":
                return " bg-gray2-dark color-black ";
            case"none":
                return "";
            default:
                return " bg-primary text-white ";
        }
    }

    render() {
        const {children, text, icon, type, classes} = this.props;

        let className = `badge ${classes} ${this.applyType(type)}`;

        return (
            <span className={className} style={{marginRight: 5, marginLeft: 5}}>
                {children ? children :
                    <>
                        {icon && <i className={`fa fa-${icon}`}/>}
                        {text}
                    </>
                }
        </span>
        );
    }
}

export default Badge;
